import Modal from '@/components/modals/modal/modal.vue'
import Scrollbar from '@/components/scrollbar/scrollbar.vue'
import OrdersChart from '@/components/orders-chart/orders-chart.vue'
import Loader from '@/components/loader/loader.vue'

const tabsFields = [
  {
    field: 'accepted',
    name: 'Прием заказов'
  },
  {
    field: 'in_delivery',
    name: 'Доставка заказов'
  }
]

export default {
  name: 'OrdersStatisticsModal',
  props: {
    dataStatistics: {
      /**
       * структура сложная - смотреть здесь https://dosta-admin.apidoc.handh.ru/#operation/v2OrderStatsExpress
       */
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Modal,
    Scrollbar,
    OrdersChart,
    Loader
  },
  static() {
    return {
      tabsFields,
      fieldsInOrder: ['today', 'week_ago', 'two_weeks_ago', 'week_ago_full_day']
    }
  },
  data() {
    const getDefaultChartDataPart = () => ({
      data: null,
      selectedIndex: 0
    })
    return {
      chartData: {
        [tabsFields[0].field]: getDefaultChartDataPart(),
        [tabsFields[1].field]: getDefaultChartDataPart()
      }
    }
  },
  methods: {
    show () {
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    },
    /**
     * 
     * @param {Array<{area_id: number; title: string}>} areas 
     */
    getAreaText(areas) {
      if (!areas.length) {
        return 'все территории'
      }
      if (areas.length === 1) {
        return 'территория: ' + areas[0].title
      }

      return 'территории: ' + areas.map(area => area.title).join(', ')
    },
    getManufacturesList(tabsField) {
      const totalItem = {
        ...this.dataStatistics[tabsField].total,
        title: 'Все'
      }
      return [ totalItem, ...this.dataStatistics[tabsField].manufactures ]
    },
    getChartData(dataObj) {
      return this.fieldsInOrder.reduce((acc, item) => {
        return [ ...acc, dataObj[item]  ]
      }, [])
    },
    setChartData(tabField, dataObj, index = 0) {
      this.chartData[tabField].selectedIndex = index
      this.chartData[tabField].data = this.getChartData(dataObj)
    }
  },
  watch: {
    dataStatistics: {
      immediate: true,
      handler() {
        if (this.dataStatistics) {
          tabsFields.forEach(tabObj => {
            this.setChartData(tabObj.field, this.dataStatistics[tabObj.field].total)
          })
        }
      }
    }
  }
}